import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="combined-schools-school-register-renewal-applications"
export default class extends Controller {
  static targets = ['form', 'registerRenewalKind', 'faculty', 'classNumber', 'period', 'selectStudentsButton', 'courseTakeButton']

  initialize() { this.switchRenewalKind() }

  switchRenewalKind() {
    if(this.isEnrollmentExtension()) {
      this.formTarget.action = 'select_students' // 対象学生選択画面へ遷移させるため
      this.periodTarget.hidden = false
      this.selectStudentsButtonTarget.hidden = true
      this.courseTakeButtonTarget.hidden = false
      this.registerRenewalKindTarget.value = 'enrollment_extension'
    } else {
      this.formTarget.action = 'select_courses' // 履修科目登録画面へ遷移させるため
      this.periodTarget.hidden = true
      this.selectStudentsButtonTarget.hidden = false
      this.courseTakeButtonTarget.hidden = true
      this.registerRenewalKindTarget.value = 'register_renewal'
    }
  }

  // 現行学年に入力された学年が最終学年か
  isEnrollmentExtension() {
    const selectFaculty = Array.from(this.facultyTarget.children).find(x => x.selected)

    return selectFaculty.dataset.lastYear == this.classNumberTarget.value
  }
}
